import React from 'react';
import { Stack, Text, ControlLink } from '@moda/om';
import { usePLPParams } from '../../hooks/usePLPParams';

export const ProductListingEmptyState: React.FC = () => {
  const { clearAllFilters } = usePLPParams();

  return (
    <Stack alignItems="center" space={2}>
      <Text treatment="body1">Sorry, there are no results that match your criteria.</Text>

      <Text treatment="body1">
        Please edit your filters to make a new selection or{' '}
        <ControlLink onClick={clearAllFilters}>clear all</ControlLink> to start over.
      </Text>
    </Stack>
  );
};
